import ApiWorkspaceRepository from "../Repositories/Workspace/ApiWorkspaceRepository";
import type {
  BaseWorkspaceRepository,
  CreateWorkspaceRequest,
  CreateWorkspaceResponse,
  SelectWorkspaceResponse,
} from "../Repositories/Workspace/BaseWorkspaceRepository.interface";
import ExperimentalWorkspaceRepository from "../Repositories/Workspace/ExperimentalWorkspaceRepository";

type WorkspaceServiceType = "api" | "experimental";

class WorkspaceService {
  private type: WorkspaceServiceType = "api";
  private Repository!: BaseWorkspaceRepository;

  constructor(type: WorkspaceServiceType) {
    this.type = type;
    this.assignRepository();
  }

  private assignRepository() {
    switch (this.type) {
      case "api":
        this.Repository = new ApiWorkspaceRepository();
        break;
      case "experimental":
        this.Repository = new ExperimentalWorkspaceRepository();
        break;
      default:
        this.Repository = new ApiWorkspaceRepository();
    }
  }

  async select(): Promise<SelectWorkspaceResponse> {
    return await this.Repository.select();
  }

  async getCurrent(): Promise<string> {
    return await this.Repository.getCurrent();
  }

  async create(workspace: CreateWorkspaceRequest): Promise<{
    error: boolean;
    message: string;
    data?: CreateWorkspaceResponse;
  }> {
    return await this.Repository.create(workspace);
  }

  async delete(workspaceId: string): Promise<{ error: boolean; message: string }> {
    return await this.Repository.delete(workspaceId);
  }

  async import(path: string): Promise<{
    error: boolean;
    message: string;
    code?: string;
    data?: CreateWorkspaceResponse;
  }> {
    return await this.Repository.import(path);
  }

  async unselect(): Promise<{ error: boolean; message: string }> {
    return await this.Repository.unselect();
  }
}

export default WorkspaceService;
